import React, { useEffect, useState } from 'react';
import { Chip, Tooltip } from '@mui/material';
import api from '../services/api';
import { reextractionText, reextractionTone } from '../utils/reextraction';

// DPS-4715: a small chip with the newest re-extraction plan for a heal job.
// Same size and tinted style as the Job Tracker's page/issue type chips.

const TONES = {
  planned: { bg: 'rgba(59, 130, 246, 0.15)', fg: '#60a5fa', border: 'rgba(59, 130, 246, 0.3)' },
  not_possible: { bg: 'rgba(245, 158, 11, 0.15)', fg: '#f59e0b', border: 'rgba(245, 158, 11, 0.3)' },
  other: { bg: 'rgba(148, 163, 184, 0.12)', fg: '#94a3b8', border: 'rgba(148, 163, 184, 0.35)' },
};

function tooltipFor(plan) {
  const bits = [];
  if (plan.planned_at) bits.push(`Plan recorded ${plan.planned_at.replace('T', ' ').slice(0, 16)} UTC`);
  if (plan.page_type) bits.push(`page type ${plan.page_type}`);
  if (plan.status === 'planned_log_only') bits.push('nothing has been re-extracted yet');
  return bits.join(' · ');
}

export default function ReextractionChip({ plan }) {
  const text = reextractionText(plan);
  if (!text) return null;
  const tone = TONES[reextractionTone(plan.status)];
  return (
    <Tooltip title={tooltipFor(plan)}>
      <Chip
        label={`Re-extraction: ${text}`}
        size="small"
        data-testid="reextraction-chip"
        sx={{
          height: 22,
          fontSize: '0.68rem',
          fontWeight: 600,
          maxWidth: '100%',
          background: tone.bg,
          color: tone.fg,
          border: `1px solid ${tone.border}`,
        }}
      />
    </Tooltip>
  );
}

/** Fetches the anomaly's re-extraction plan (via its own heal jobs) and shows it; nothing when none or on error. */
export function AnomalyReextractionChip({ anomalyId }) {
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    setPlan(null);
    if (!anomalyId) return undefined;
    let live = true;
    // Promise.resolve().then(): a missing or throwing API method stays fail-soft too.
    Promise.resolve()
      .then(() => api.getAnomalyReextraction(anomalyId))
      .then((body) => { if (live) setPlan(body?.reextraction || null); })
      .catch(() => { if (live) setPlan(null); });
    return () => { live = false; };
  }, [anomalyId]);
  return <ReextractionChip plan={plan} />;
}
